import { useFormikContext } from 'formik';
import React = require('react');
import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { SessionServerSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { Messages } from '~src/codegen/Localize';
import { SettingsSection } from '~src/settings/components/common/SettingsSection';

import { useSelector } from '../../../utils';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const DQW_SUBSCRIPTION_EMAILS_SECTION_TEST_ID = 'dqw-subscription-email-setting-section';
export const DQW_SUBSCRIPTION_EMAILS_CHECKBOX_TEST_ID = 'dqw-subscription-email-setting-checkbox';
export const DQW_SUBSCRIPTION_EMAILS_FIELD = 'settings.dqwSubscriptionsEnabled';

export type DataQualitySubscriptionSectionProps = SiteSettingsForSiteAdminProps<'dqwSubscriptionsEnabled' | 'subscriptionSettings'>;

export function DataQualitySubscriptionSection() {
    const catalogingEnabledOnServer = useSelector(SessionServerSelectors.isCatalogingOnServerEnabled);
    const formik = useFormikContext<DataQualitySubscriptionSectionProps>();

    return (
        catalogingEnabledOnServer &&
        formik.initialValues.settings.subscriptionSettings
        ? <SettingsSection testId={DQW_SUBSCRIPTION_EMAILS_SECTION_TEST_ID}
                           title={Messages.dqwSubscriptionEmailSetting()}
                           description={renderDescription()}>
            <FormikCheckbox name={DQW_SUBSCRIPTION_EMAILS_FIELD}
                            label={Messages.allowDqwSubscriptionEmailsOnSite()}
                            testId={DQW_SUBSCRIPTION_EMAILS_CHECKBOX_TEST_ID}/>
          </SettingsSection>
        : null
    );
}

function renderDescription(){
    return(
        <div>
            {Messages.dqwSubscriptionEmailSettingDescription()}
        </div>
    );
}

export const DataQualitySubscriptionSectionSpec = componentRegistryEntry({
    name: 'DataQualitySubscriptionSection',
    component: DataQualitySubscriptionSection
});

